import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const WithdrawIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M9.5 15L12 17.5L14.5 15M12 10.5V16.8912" />
      <path d="M19.1851 19.2363L17.2944 8.64842C17.124 7.69456 16.2944 7 15.3255 7H8.67449C7.70555 7 6.87597 7.69456 6.70564 8.64842L4.81494 19.2363C4.65077 20.1557 5.35764 21 6.29159 21H17.7084C18.6424 21 19.3492 20.1557 19.1851 19.2363Z" />
      <path d="M21 11C21.8626 10.7762 22 9.98695 22 9.04763V5.01588C22 3.90254 21.1046 3 20 3H4C2.89543 3 2 3.90254 2 5.01588V9.04763C2 9.98695 2.13739 10.7762 3 11" />
    </SvgIcon>
  )
}
